import { SignupForm } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import { MerchantCustomizableModal } from "@redotech/redo-web/storefront/merchant-customizable-modal";
import { ANONYMOUS_SHOPPER_ID_KEY } from "@redotech/redo-web/utils/shared-conf";
import { memo } from "react";
import { CustomFieldProvider } from "../form-elements/context";
import { SignupForm as SignupFormComponent } from "../signup-form";
import { SignupFormClient } from "./types";
import { getOpacityHex } from "./utils";

export interface SharedFormModalProps {
  ariaLabel?: string;
  form: SignupForm;
  open: boolean;
  completed: boolean;
  currentStep: number;
  onClose: () => void;
  client: SignupFormClient | undefined;
  brandKit?: any;
  merchantPhoneNumber?: string;
  discountCode?: string;
  onSubmitStep: (args: {
    stepIndex: number;
    formData: Record<string, string>;
    shouldAdvance?: boolean;
  }) => Promise<void>;
  onCreatePendingTextToSubscribeRecord?: () => Promise<string | undefined>;
}

export const SharedFormModal = memo(function SharedFormModal({
  ariaLabel,
  form,
  open,
  completed,
  currentStep,
  onClose,
  client,
  brandKit,
  merchantPhoneNumber,
  discountCode,
  onSubmitStep,
  onCreatePendingTextToSubscribeRecord,
}: SharedFormModalProps) {
  const opacityHex = getOpacityHex(form);

  return (
    <MerchantCustomizableModal
      ariaLabel={ariaLabel}
      backdropColor={form.theme.overlay.color + opacityHex}
      fullscreen={form.layout.type === "fullscreen"}
      onClose={onClose}
      open={open && !completed}
    >
      <CustomFieldProvider
        getCustomFieldOptions={(id) =>
          client?.getCustomFieldOptions({ customFieldId: id }) ??
          Promise.resolve({ name: "", options: [] })
        }
      >
        <SignupFormComponent
          anonymousId={
            localStorage.getItem(ANONYMOUS_SHOPPER_ID_KEY) ?? undefined
          }
          brandKit={brandKit}
          currentStep={currentStep}
          discountCode={discountCode}
          form={form}
          merchantPhoneNumber={merchantPhoneNumber}
          onClose={onClose}
          onCreatePendingTextToSubscribeRecord={
            onCreatePendingTextToSubscribeRecord
          }
          onSubmitStep={onSubmitStep}
        />
      </CustomFieldProvider>
    </MerchantCustomizableModal>
  );
});
